import { FormField, Input } from '@/shared/components';

interface WizardFieldProps {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  hint?: string;
  type?: 'text' | 'number';
  min?: number;
  className?: string;
}

/** Kompaktes Text-/Zahlfeld für den Create-Wizard — FormField + Input mit string-onChange. */
export function WizardField({
  label,
  value,
  onChange,
  error,
  required,
  hint,
  type = 'text',
  min,
  className,
}: WizardFieldProps) {
  return (
    <FormField label={label} error={error} hint={hint} required={required} className={className}>
      <Input
        type={type}
        min={min}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </FormField>
  );
}
